import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export async function apiGetScreenTemplateChildren(templateId, screenId, playlistId) {
  try {
    const endpoint = `${config.apiUrl}userapi/screens/${screenId}/template/${templateId}/children`;
    const query = playlistId ? `?playlist_id=${playlistId}` : '';

    return await http.get(`${endpoint}${query}`);
  } catch (error) {
    logger.addLog(
      `Template's children API failed: ${error?.message}. Local template: ${templateId}. ${
        playlistId ? `Playlist: ${playlistId}` : ''
      }`,
    );

    return null;
  }
}
